export const theme = {
  colors: {
    // Refined Teal & Warm Accent palette (modern, calm, professional)
    primary: '#0d9488',        // Teal 600
    secondary: '#f59e0b',      // Amber 500 (warm accent)
    accent: '#38bdf8',         // Light sky for subtle highlights
    background: '#F6FBF9',     // Very light minty background
    surface: '#FFFFFF',    // White surfaces
    border: '#E6F8F6',         // Very light teal border
    textHigh: '#0F172A',       // Dark slate for high-contrast text
    textMid: '#475569',        // Muted slate for secondary text
    textDim: '#94A3B8',        // Dim text
    success: '#16a34a',        // Green
    warning: '#f59e0b',        // Amber
    error: '#ef4444',          // Red
    gradientPrimary: 'linear-gradient(135deg, #0d9488 0%, #5EEAD4 100%)',
    gradientSecondary: 'linear-gradient(135deg, #f59e0b 0%, #ffbf69 100%)',
  },

  fonts: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Space Grotesk", "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    mono: '"JetBrains Mono", "Fira Code", monospace'
  },
  fontSizes: {
    xs: '0.75rem', sm: '0.875rem', base: '1rem', lg: '1.125rem', xl: '1.25rem', '2xl': '1.5rem', '3xl': '1.875rem', '4xl': '2.25rem', '5xl': '3rem', '6xl': '3.5rem'
  },
  fontWeights: { light:300, normal:400, medium:500, semibold:600, bold:700, extrabold:800 },
  spacing: { xs:'0.5rem', sm:'0.875rem', md:'1.25rem', lg:'2rem', xl:'3rem', '2xl':'4.5rem', '3xl':'6.5rem', '4xl':'9rem' },
  // Breakpoint sizes for responsive design
  breakpoints: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px', '2xl': '1536px' },
  radii: { sm:'4px', md:'8px', lg:'14px', xl:'24px', pill:'999px' },
  // Backward compatible borderRadius API
  borderRadius: { sm:'4px', base:'4px', md:'8px', lg:'14px', xl:'24px', '2xl':'24px', '3xl':'32px', full:'999px' },
  shadows: { xs:'0 1px 2px rgba(0,0,0,0.06)', sm:'0 6px 16px rgba(15,23,42,0.06)', md:'0 12px 34px rgba(2,6,23,0.08)', lg:'0 18px 44px rgba(2,6,23,0.09)', innerGlow:'inset 0 0 0 1px #FFFFFF05, 0 0 0 1px #FFFFFF05', xl:'0 20px 40px -8px rgba(2,6,23,0.12)', '2xl':'0 28px 64px -12px rgba(2,6,23,0.14)', primaryShadow:'0 10px 30px rgba(13,148,136,0.18)', secondaryShadow:'0 10px 30px rgba(245,158,11,0.14)', glassShadow:'0 8px 32px 0 rgba(13,148,136,0.12)' },
  transitions: { fast:'0.15s ease', base:'0.25s cubic-bezier(.4,.2,.2,1)', slow:'0.45s cubic-bezier(.4,.2,.2,1)', elastic:'0.4s cubic-bezier(0.68,-0.55,0.265,1.55)' },
  zIndex: { behind:-1, base:1, overlay:10, dropdown:1000, sticky:1020, modal:1050, popover:1060, tooltip:1070 },
  layout: { contentMaxWidth:'1240px' }
};